/*************
 * productCardPillow
 *
 */

custom.productCardPillow = (() => {
  const pillowCardClassName = 'js-product-card-pillow';

  function applyActiveClassToImg(event = {}) {
    const imgId = $(event.currentTarget).data('target-img-id'),
      $card = $(event.currentTarget).closest(`.${pillowCardClassName}`);

    if ($card.find('.product-card__image').length > 1) {
      $card
        .find('.product-card__sizes')
        .addClass('product-card__sizes--multiple');
      $card
        .find('[data-target-img-id]')
        .each((index, span) => $(span).removeClass('active'));
      $card.find('[data-img-id]').each((index, img) => {
        $(img).removeClass('active');
        if ($(img).data('img-id') === imgId) {
          $(img).addClass('active');
        }
      });
      $(event.currentTarget).addClass('active');
    }
  }

  function hoverHandler(card) {
    const sizeLabels = $(card).find('[data-target-img-id]');
    $(card).find('[data-img-id]').first().addClass('active');
    $.each(sizeLabels, (index, label) => {
      $(label).on('mouseover', applyActiveClassToImg);
    });
  }

  const init = () => {
    if ($(`.${pillowCardClassName}`).length > 0)
      $.each($(`.${pillowCardClassName}`), (index, card) => {
        hoverHandler(card);
      });
  };

  return {
    init,
  };
})();



// WEBPACK FOOTER //
// ./src/scripts/src/custom/product-card-pillow.js